(function () {
  'use strict';

  if (window.PGHomePolishV33R4) return;
  window.PGHomePolishV33R4 = true;

  var observer = null;
  var observedCue = null;

  function restoreCue(cue) {
    if (!cue) return;
    if (cue.classList.contains('is-dismissed')) cue.classList.remove('is-dismissed');
    if (cue.hasAttribute('aria-hidden')) cue.removeAttribute('aria-hidden');
  }

  function watchCue(cue) {
    if (!window.MutationObserver || !cue || observedCue === cue) return;
    if (observer) observer.disconnect();

    observedCue = cue;
    observer = new MutationObserver(function () {
      restoreCue(cue);
    });
    observer.observe(cue, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function init() {
    var cue = document.querySelector('.pg-swipe-cue--likeness');
    if (!cue) return;

    restoreCue(cue);
    watchCue(cue);

    [80, 240, 480, 900].forEach(function (delay) {
      window.setTimeout(function () { restoreCue(cue); }, delay);
    });
  }

  function boot() {
    init();
    [120, 400, 900, 1800].forEach(function (delay) {
      window.setTimeout(init, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    observedCue = null;
    window.setTimeout(init, 0);
  });

  window.addEventListener('pagehide', function () {
    if (observer) observer.disconnect();
  }, { once: true });
})();
